import { GetTranslationFunc } from '@/types/translationTypes';
import { IValidator } from '@/utils/validator';

export type ValidationField = 'name' | 'maxCompanies';

export const getValidators = (getTranslation: GetTranslationFunc): { [key: string]: IValidator[] } => ({
	name: [{
		type: 'notEmpty',
		message: getTranslation('common.validators.not-empty')
	}, {
		type: 'len',
		options: {
			max: 50
		},
		message: getTranslation('administration.organizations.validators.name-max-length')
	}],
	maxCompanies: [{
		type: 'notEmpty',
		message: getTranslation('common.validators.not-empty')
	}, {
		type: 'pattern',
		options: {
			pattern: /^[1-9]\d*$/
		},
		message: getTranslation('administration.organizations.validators.positive-integer')
	}]
});
